import { useQuery, keepPreviousData } from '@tanstack/react-query'
import type { FixedOddsEventDetailsResponse } from '@core/Areas/RaceCardFixedOnly/Data/types'
import { queryKeys } from '@core/Data/ReactQuery/constants'
import { getFixedOddsEventDetails } from '@core/Areas/RaceCardFixedOnly/Data/api'
import { RaceProduct } from '@core/Areas/RaceCardFixedOnly'
import type { RaceCodesLowerCase } from '@core/Areas/Racing/Types/MeetingInformation'

type Props = {
  raceProduct: RaceProduct
  raceCode: RaceCodesLowerCase
  competitionNumber: string
}

export function useFixedOddsEventDetails({ raceProduct, raceCode, competitionNumber }: Props) {
  return useQuery<FixedOddsEventDetailsResponse>({
    queryKey: [queryKeys.eventDetails, raceProduct, raceCode, competitionNumber],
    queryFn: () => getFixedOddsEventDetails(raceProduct, raceCode, competitionNumber),
    retry: false,
    gcTime: 0,
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
  })
}
